import { Layout } from '@/components/Layout'
import { GOOGLE_CLIENT_ID } from '@/env'
import { Toaster } from '@/ui-kit/components/Sonner'
import { LocaleProvider, ThemeProvider } from '@/ui-kit/providers'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { StrictMode } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { GoogleTagManagerProvider } from './components/GoogleTagManagerProvider'
import { ReactQueryProvider } from './components/ReactQueryProvider'
import { SessionProvider } from './features/authorization/components/SessionProvider'
import { SolanaWalletProvider } from './features/stake-sol/providers/SolanaWalletProvider'

export const App = () => {
  return (
    <StrictMode>
      <LocaleProvider>
        <ThemeProvider>
          <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
            <ReactQueryProvider>
              <SolanaWalletProvider>
                <GoogleTagManagerProvider />
              <BrowserRouter>
                <SessionProvider>
                  <Toaster />
                  <Layout />
                </SessionProvider>
              </BrowserRouter>
            </SolanaWalletProvider>
            </ReactQueryProvider>
          </GoogleOAuthProvider>
        </ThemeProvider>
      </LocaleProvider>
    </StrictMode>
  )
}
